import TodoListItem from "./TodoListItem";

interface ITodoList {
  todos: TodoType[];
  toggleTodo: ToggleFn;
  editTodo: EditFn;
  deleteTodo: DeleteFn;
}

const TodoList = ({ todos, toggleTodo, deleteTodo, editTodo }: ITodoList) => {
  return (
    <ul className="fade-in">
      {todos.map((item, index) => (
        <TodoListItem
          key={item.id}
          item={item}
          toggleTodo={toggleTodo}
          deleteTodo={deleteTodo}
          editTodo={editTodo}
          index={index}
        />
      ))}
    </ul>
  );
};

export default TodoList;